import React, { useEffect, useRef, useState } from 'react';
import CryptoJS from 'crypto-js';
import candidateAvatar from '../../assets/img/avatar-grey.png';
import ClaimedAdvancedSearch, { ClaimedCandidateModalBox } from './advanced-search-form';
import { claimedCandidateExternalService } from '../../lib/api/claimed';
import { ClaimedCandidateGlobalRequestType, DecyptedClaimedCandidateGlobalType } from '../../types/claimed';
import { claimedCandKey, hashSecretKey } from '../../config/constants';
import FAQImg from '../../assets/img/faq-search-icon.png';
import { routes } from '../routes/routes-names';
import StateCityCodeValue from '../../components/profile/stateCityCodeValue';
import Hashids from 'hashids';
import { useNavigate } from 'react-router-dom';

const hashids = new Hashids(hashSecretKey, 8);

const ClaimedSearchBox = () => {
    const [showInputDropdown, setShowInputDropdown] = useState(false);
    const [show, setShow] = useState(false);
    const [isCandidateSearchBox, setIsCandidateSearchBox] = useState(true);
    const [externalCandData, setExternalCandData] = useState<DecyptedClaimedCandidateGlobalType[]>([]);
    const [showSignUpPage, setShowSignUpPage] = useState(false);
    const [showLoginPage, setShowLoginPage] = useState(false);

    const [searchPerformed, setSearchPerformed] = useState(false);

    const handleLoginPageModal = () => setShowLoginPage(false);

    const inputDropdownRef = useRef<HTMLUListElement>(null);

    const navigate = useNavigate();

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setShowInputDropdown(false);
    };

    const handleInputClick = () => {
        setShowInputDropdown(true);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (inputDropdownRef.current && !inputDropdownRef.current.contains(event.target as Node)) {
            setShowInputDropdown(false);
        }
    };

    const fetchCandidates = async (value: string) => {
        if (value.length === 0) {
            setExternalCandData([]);
            setSearchPerformed(false);
            setShowInputDropdown(false);
            return;
        }
        setSearchPerformed(true);
        try {
            const params: ClaimedCandidateGlobalRequestType = {
                Start: 0,
                Limit: 5,
                'SearchParam.FilterValue': value,
                'SearchParam.SortType': 0,
            };
            const { resultObject } = await claimedCandidateExternalService.getClaimedCandiateList(params);
            const decyptedHashedData = resultObject.map((item: any) => decryptData(item.hash, false));
            setExternalCandData(decyptedHashedData);
            // setShowInputDropdown(true);
            setShowInputDropdown(decyptedHashedData.length > 0 || searchPerformed);
        } catch (error) {
            console.log(error, 'External candidate error');
        }
    };

    const showClaimedModal = (externalCandData: DecyptedClaimedCandidateGlobalType) => {
        if (externalCandData.IsUser == 0) {
            setShowLoginPage(true);
            setShowSignUpPage(false);
        } else {
            setShowLoginPage(false);
            navigate(routes.claimProcess, {
                state: {
                    data: externalCandData,
                },
            });
        }
    };

    const debouncedFetchCandidates = debounce(fetchCandidates, 300);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (inputDropdownRef.current && !inputDropdownRef.current.contains(event.target as Node)) {
                setShowInputDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        debouncedFetchCandidates(ev.target.value);
    };

    return (
        <>
            <div className="input-group mb-3 border-hvr">
                <div className="ext-search">
                    <div className="search-icon">
                        <i className="bi bi-search"></i>
                    </div>
                    <input
                        type="text"
                        className="form-control fs-14"
                        aria-label="Text input with dropdown button"
                        placeholder={isCandidateSearchBox ? 'Search candidate' : 'Search company'}
                        onClick={handleInputClick}
                        onChange={handleInputChange}
                    />
                    {showInputDropdown && (
                        <>
                            <ul
                                ref={inputDropdownRef}
                                className="fs-14 dropdown-menu show"
                                style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    zIndex: 1000,
                                    width: '100%',
                                }}
                            >
                                {externalCandData.length > 0
                                    ? externalCandData.map((item, index) => {
                                          return (
                                              <li key={index} className="border-bottom-1">
                                                  <span
                                                      className="dropdown-item"
                                                      onClick={() => showClaimedModal(item)}
                                                  >
                                                      <div className="d-flex mb-2">
                                                          <div>
                                                              <img
                                                                  src={candidateAvatar}
                                                                  alt=""
                                                                  className="avatar avatar--xs2"
                                                                  title="My profile"
                                                              />
                                                          </div>
                                                          <div className="flex-column ms-2">
                                                              <div
                                                                  className="fs-14 fw-600"
                                                                  style={{
                                                                      lineBreak: 'anywhere',
                                                                      whiteSpace: 'break-spaces',
                                                                  }}
                                                              >
                                                                  {item.FirstName} {item.MiddleName || ''}{' '}
                                                                  {item.LastName || ''}
                                                              </div>
                                                              <div className="fs-12 lt-text-secondary">
                                                                  {item?.IsUser === 1 ? (
                                                                      <span className="">
                                                                          {item?.CandidateLocation}
                                                                      </span>
                                                                  ) : (
                                                                      <StateCityCodeValue
                                                                          id={item.Id}
                                                                          countryValue={item.Country}
                                                                          cityValue={item.CityDistrict}
                                                                          stateValue={item.State}
                                                                      />
                                                                  )}
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </span>
                                              </li>
                                          );
                                      })
                                    : searchPerformed && (
                                          <div className="d-flex align-items-center justify-content-center py-1">
                                              <div className="text-center">
                                                  <img
                                                      src={FAQImg}
                                                      alt="We could not find results for your search"
                                                      className="ox-no-search-img"
                                                  />
                                                  <p className="fs-14">No results found.</p>
                                              </div>
                                          </div>
                                      )}

                                <div className="text-center mt-3">
                                    <button className="btn btn-primary" onClick={handleShow}>
                                        Advanced Search
                                    </button>
                                </div>
                            </ul>
                        </>
                    )}
                </div>
                <button
                    className="btn drop-btn pointer-events-none lt-text-primary-alt fs-14"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    {isCandidateSearchBox ? 'Candidate' : 'company'}
                </button>
                <ClaimedAdvancedSearch handleClose={handleClose} show={show} />
                {showLoginPage && ClaimedCandidateModalBox(showLoginPage, handleLoginPageModal)}
            </div>
        </>
    );
};

export default ClaimedSearchBox;

function debounce<T extends (...args: any[]) => void>(func: T, delay: number) {
    let timeoutId: NodeJS.Timeout | null;

    return function (this: any, ...args: Parameters<T>) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

export function decryptData(hash: string, internal: boolean = false): any {
    const [iv, encryptedData] = hash.split('##');

    const ivBytes = CryptoJS.enc.Base64.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(encryptedData, CryptoJS.enc.Base64.parse(claimedCandKey), { iv: ivBytes });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    if (internal) {
        return decryptedText;
    } else {
        return JSON.parse(decryptedText);
    }
}

export function encryptData(data: string, internal: boolean = false): any {
    const dataString = internal ? data : JSON.stringify(data);

    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(dataString, CryptoJS.enc.Base64.parse(claimedCandKey), { iv: iv });

    const encryptedData = encrypted.toString();

    const ivBase64 = iv.toString(CryptoJS.enc.Base64);
    return `${ivBase64}##${encryptedData}`;
}

export const decodeProfileId = (hash: string) => {
    const decodedNumbers = hashids.decode(hash);
    const bytes = convertLongsToBytes(decodedNumbers);
    return new TextDecoder().decode(bytes).replace(/\0/g, ''); // Trim null characters
};
export const encodeProfileId = (input: string) => {
    const bytes = new TextEncoder().encode(input);
    const numbers = convertBytesToLongs(bytes);
    return hashids.encode(numbers);
};

const convertBytesToLongs = (bytes: any) => {
    const numLongs = Math.ceil(bytes.length / 8);
    let longs = new Array(numLongs).fill(0);

    for (let i = 0; i < numLongs; i++) {
        let temp = new Uint8Array(8).fill(0);
        let length = Math.min(8, bytes.length - i * 8);
        temp.set(bytes.slice(i * 8, i * 8 + length));
        longs[i] = new DataView(temp.buffer).getBigInt64(0, true);
    }

    return longs;
};

const convertLongsToBytes = (longs: any) => {
    let bytes = new Uint8Array(longs.length * 8);

    for (let i = 0; i < longs.length; i++) {
        let temp = new DataView(new ArrayBuffer(8));
        temp.setBigInt64(0, BigInt(longs[i]), true);
        bytes.set(new Uint8Array(temp.buffer), i * 8);
    }

    return bytes;
};
